import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { RevenueStoreEffects } from './revenue.effects';
import { dashboardRevenueStoreFeatureKey, reducer } from './revenue.reducers';

export function provideRevenueStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(dashboardRevenueStoreFeatureKey, reducer),
    provideEffects([RevenueStoreEffects]),
  ]);
}
